import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { Stack } from '../../../Stack';

export const PaginationWrapper = styled(Stack)`
    margin-top: ${getToken(TokenName.SPACING_300)}px;
`;

export const PaginationSizeSelectorWrapper = styled.div`
    min-width: 80px;
`;

export const PaginationSizeWrapper = styled(Stack)`
    ${getTextTokenPreset('BODY_L_STRONG')}
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
`;
